export default __webpack_public_path__ + "static/media/x21.b21987eb.svg";